import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface NotificationBellIcon extends SVGProps<SVGSVGElement> {
  label?: string
}

const NotificationBellIcon: React.FC<NotificationBellIcon> = ({
  label = 'notificationBell',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="notification-bell-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 17H22V19H2V17H4V10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10V17ZM9 21H15V23H9V21Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default NotificationBellIcon
